module.exports = __webpack_public_path__ + "static/media/bike.8b4ac43c.svg";